<script>
   /*************************************************************
   * AppLegend                                                  *
   * --------------------                                       *
   * shows legend for cal and pv series                         *
   **************************************************************/

   import { Legend } from 'svelte-plots-basic/2d';
   import { ps } from './settings.js';

   export let position = 'topright';
</script>

<Legend {position} items={[
   { label: 'cal', marker: ps.cal.marker, borderColor: ps.cal.borderColor, faceColor: ps.cal.faceColor },
   { label: 'pv',  marker: ps.pv.marker,  borderWidth: ps.pv.borderColor,  borderColor: ps.pv.borderColor }
]} />
